module.exports = __webpack_public_path__ + "static/media/event10.de866948.jpeg";